angular.module('app').factory('ViewMediaModalService', function ($uibModal) {
    let fac = {
        open: open
    };
    function open(media) {
        let modalInstance = $uibModal.open({
            backdrop: 'static',
            animation: true,
            component: 'viewMediaModalComponent',
            size: 'md',
            windowClass: 'view-media', // see app-modals.css for settings
            resolve: {
                media: () => {
                    return media;
                }
            }
        });
    }
    return fac;
});
